import { render, staticRenderFns } from "./HeaderTags.vue?vue&type=template&id=590c98b2&scoped=true"
import script from "./HeaderTags.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderTags.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeaderTags.vue?vue&type=style&index=0&id=590c98b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590c98b2",
  null
  
)

export default component.exports